export default "__VITE_ASSET__B8nNV2E4__"